<!-- src\components\Group461.vue -->

<template>
  <div :class="[`group-461`, className || ``]">
    <div class="group-title poppins-semi-bold-white-22px">Академия</div>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('home')">Главная</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('about')">О нас</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('career')">Карьера</a>
    <a href="#" class="text-link poppins-normal-boulder-22px" @click.prevent="handleClick('privacy')">Privacy Policy</a>
  </div>
</template>

<script>
export default {
  name: "Group461",
  props: ["className"],
  methods: {
    handleClick(page) {
      console.log('Клик по странице:', page);
      // Заглушка - здесь будет навигация
      // this.$router.push(`/${page}`);
    }
  }
};
</script>

<style scoped>
.group-461 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;              /* Вместо margin-top на каждом элементе */
  left: 431px;
  position: absolute;
  top: 560px;
  width: 171px;
}

.group-title {
  letter-spacing: 0.88px;
  line-height: 1.4;
  white-space: nowrap;    /* Не переносить заголовок */
}

.text-link {
  display: block;
  letter-spacing: 0.88px;
  line-height: 1.4;       /* Вместо фиксированной высоты */
  text-align: left;
  cursor: pointer;
  color: #797979;
  transition: color 0.3s ease;
  text-decoration: none;
  white-space: nowrap;    /* Не переносить текст */
}

.text-link:hover {
  color: #ffffff;
}

.group-461.group-461-1,
.group-461.group-461-2,
.group-461.group-461-3,
.group-461.group-461-4,
.group-461.group-461-5,
.group-461.group-461-6,
.group-461.group-461-7,
.group-461.group-461-8,
.group-461.group-461-9,
.group-461.group-461-10,
.group-461.group-461-11,
.group-461.group-461-12,
.group-461.group-461-13 {
  left: unset;
  position: unset;
  top: unset;
}
</style>